import styled from 'styled-components';

export const InputRow = styled.div`
  display: flex;
  align-items: center;
  gap: 64px;

  .set-hours {
    align-items: flex-end;
    gap: 16px;

    > svg {
      margin-bottom: 8px;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;

    > div {
      width: 100%;
    }
  }
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${(props) => props.theme.colors.btnDisabledBg};
  margin: 40px auto;
`;

export const FileImg = styled.img`
  width: 30px;
  height: 30px;
  display: block;
`;
